import { inject } from '@angular/core';
import { ActivatedRoute, ResolveFn, Router } from '@angular/router';

import { catchError, filter, map, of, skipWhile, switchMap, take, tap } from 'rxjs';

import { AuthGrpcContractService } from '../api/grpc/services/auth.service';
import { RouteString } from '../enums/route-string';
import { AuthStatusCookieService } from '../services/auth-status-cookie.service';
import { ErrorService } from '../services/error.service';
import { TokenService } from '../services/token.service';
import { SettingSelectService } from '../store/selectors';

export const questionnaireResolver: ResolveFn<boolean> = (route) => {
  const _auth = inject(AuthGrpcContractService);
  const _tokenService = inject(TokenService);
  const _errorService = inject(ErrorService);
  const _router = inject(Router);
  const _activatedRoute = inject(ActivatedRoute);
  const _settingSelect = inject(SettingSelectService);
  const _authStatusCookieService = inject(AuthStatusCookieService);
  // const referrer = _settingSelect.referrerSignal();

  return _settingSelect.validToken().pipe(
    switchMap((x) => {
      if (x) {
        return of(true);
      } else {
        return _auth.register({ Language: 'en', RegistrationWpcRequest: {} }).pipe(
          skipWhile((v) => v === null || v === undefined),
          filter((y) => !!y),
          tap(({ Token }) => {
            if (Token) {
              _tokenService.token = Token;
              _authStatusCookieService.clear();
            }
          }),
          take(1),
          map(() => true),
          catchError((response) => {
            const homePath = (route.routeConfig?.data?.['config']?.homePath as RouteString) ?? RouteString.MAIN;
            _router.navigate(['/', route.params['lang'], homePath], {
              relativeTo: _activatedRoute,
              queryParamsHandling: 'merge',
            });
            return _errorService.handleApiError(response, 'AuthGrpcContractClient.Register');
          }),
        );
      }
    }),
  );
};
